<template>
  <div>
    <section class="section hero is-secondary">
      <h2 class="title">How does it work?</h2>
      <div class="columns is-multiline is-centered">
        <div class="column is-one-quarter">
          <div
            @click="
              redirect(
                'https://www.facebook.com/groups/Flow.makemeflow/permalink/2947700785314492/'
              )
            "
            class="card"
          >
            <div class="card-content">
              <div class="subtitle card-item">
                Highly curated and interdisciplinary opportunities daily
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div
            @click="
              redirect(
                'https://www.facebook.com/groups/Flow.makemeflow/permalink/2959747790776458/'
              )
            "
            class="card"
          >
            <div class="card-content">
              <div class="subtitle card-item">
                Build unique credentials, emerging skills, and expanding
                awareness
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div
            @click="
              redirect(
                'https://www.facebook.com/591289325/videos/10158253603504326/'
              )
            "
            class="card"
          >
            <div class="card-content">
              <div class="subtitle card-item">
                Connect to inspiring peers for personalised recommendations
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="column is-one-quarter">
          <div class="card">
            <div class="card-image">
              <figure class="image is-4by3">
                <img
                  src="https://bulma.io/images/placeholders/1280x960.png"
                  alt="Placeholder image"
                />
              </figure>
            </div>
            <div class="card-content">
              <div class="content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Phasellus nec iaculis mauris.
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    redirect(url) {
      window.open(url);
    }
  }
};
</script>

<style scoped>
.card {
  cursor: pointer;
  border-radius: 5px;
  background-color: #082257;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.subtitle {
  color: white;
}
.card-item {
  /* padding: 0.5rem; */
}
</style>
